import React, { useState } from "react";

// Material-UI
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";

// Styles
import useStyles from "./StyleDialog";
import Gap from "../../../components/atoms/Gap";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  ListItem,
  Typography,
  Paper,
  Button,
  CircularProgress,
  DialogTitle,
  IconButton,
} from "@material-ui/core";
import currency from "../../../utils/currency";
import { delimiters } from "../../../utils/currency";
import { ExpandMore } from "@material-ui/icons";
import DialogTracking from "./DialogTracking";
import {
  useCollectionDataOnce,
  useDocumentDataOnce,
} from "react-firebase-hooks/firestore";
import { firestore } from "../../../components/firebase/FirebaseProvider";
import { useData } from "../../../components/firebase/DataProvider";
import { green } from "@material-ui/core/colors";
import { dateTime } from "../../../utils/dateTime";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import CopyToClipboard from "react-copy-to-clipboard";
import { useSnackbar } from "notistack";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

function DetailDialog({ open, handleClose, orderId }) {
  const classes = useStyles();
  const { profil } = useData();
  const orderRef = firestore.doc(`orders/${orderId}`);
  const [order, orderLoading] = useDocumentDataOnce(orderRef, {
    idField: "id",
  });
  const [suborders, subordersLoading] = useCollectionDataOnce(
    orderRef
      .collection("suborders")
      .where("order_info.owner_id", "==", profil.id),
    { idField: "id" }
  );

  const { enqueueSnackbar } = useSnackbar();

  const handleWa = (item) => () => {
    // console.log("hasil", item?.replace(/-|[+]/gm, "") ?? "");
    window.open(
      `https://wa.me/${
        item?.replace(/-|[+]/gm, "") ?? ""
      }?text=Hallo kak ada barang yang belum di bayar nih di Tokorame`
    );
  };

  const handleResi = (item) => () => {
    // console.log("hasil", item?.replace(/-|[+]/gm, "") ?? "");
    window.open(item);
  };

  const [dialogTrac, setDialogTrac] = useState({
    open: false,
    subOrder: {},
  });

  const handleTrac = (item) => (e) => {
    setDialogTrac({
      open: true,
      subOrder: item,
    });
  };

  return (
    <Dialog
      open={open}
      fullScreen
      PaperProps={{
        style: { maxWidth: 960 },
      }}
      onClose={handleClose}
    >
      {/* <Header title="Detail Order" type="with-title" onClick={handleClick} /> */}
      {/* <Gap height={60} /> */}
      <DialogTitle>
        <div style={{ display: "flex", alignItems: "center" }}>
          <IconButton
            size="small"
            onClick={handleClose}
            style={{ marginRight: 15 }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography>Detail Order</Typography>
        </div>
      </DialogTitle>
      {orderLoading || subordersLoading ? (
        <>
          {/* <Gap height={60} /> */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "calc(100vh - 60px)",
            }}
          >
            <CircularProgress />
          </div>
        </>
      ) : (
        <DialogContent dividers style={{ padding: 10 }}>
          <Paper>
            <ListItem className={classes.padding}>
              <Grid container>
                <Grid item xs>
                  <Typography variant="caption" display="block">
                    Status Transaksi :
                  </Typography>
                </Grid>

                <Grid item>
                  <Typography
                    variant="caption"
                    display="block"
                    style={{
                      color: green[500],
                    }}
                  >
                    <b>{order?.status?.toUpperCase()}</b>
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
          </Paper>
          <Gap height={10} />
          <Paper>
            <ListItem className={classes.padding}>
              <Grid container>
                <Grid item xs>
                  <Typography variant="caption" display="block">
                    Kode Order :
                  </Typography>
                </Grid>

                <Grid item>
                  <CopyToClipboard
                    text={order?.kode_order}
                    onCopy={() => {
                      enqueueSnackbar("Kode Order Berhasil Disalin", {
                        variant: "success",
                      });
                    }}
                  >
                    <Typography variant="caption" display="block">
                      <b>{order?.kode_order}</b>
                      <FileCopyOutlinedIcon
                        style={{ width: "12", height: "12", marginLeft: "5" }}
                      />
                    </Typography>
                  </CopyToClipboard>{" "}
                </Grid>
              </Grid>
            </ListItem>
            <ListItem className={classes.padding}>
              <Grid container>
                <Grid item xs>
                  <Typography variant="caption" display="block">
                    Waktu Pemesanan :
                  </Typography>
                </Grid>

                <Grid item>
                  <Typography variant="caption" display="block">
                    {dateTime(order?.created_at?.toDate?.() ?? new Date())}
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
            {order?.paid_at?.toDate?.() ? (
              <ListItem className={classes.padding}>
                <Grid container>
                  <Grid item xs>
                    <Typography variant="caption" display="block">
                      Waktu Pembayaran :
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography variant="caption" display="block">
                      {dateTime(order?.paid_at?.toDate?.())}
                    </Typography>
                  </Grid>
                </Grid>
              </ListItem>
            ) : null}
          </Paper>{" "}
          <Gap height={10} />
          {/* <Divider /> */}
          {suborders?.map((suborder, index) => {
            console.log("suborder", suborder);

            return (
              <div key={index}>
                <Paper>
                  <ListItem divider className={classes.pesanan}>
                    <Grid container>
                      <Grid item xs>
                        <Typography variant="caption" display="block">
                          <b>{`Pesanan ${index + 1}`}</b>
                        </Typography>
                      </Grid>
                    </Grid>
                  </ListItem>
                  {suborder?.resi_otomatis_mp ? (
                    <ListItem
                      style={{ backgroundColor: "#C9D6FC" }}
                      className={classes.accordion}
                    >
                      <Grid container>
                        <Grid item xs>
                          <Typography variant="caption" display="block">
                            Kode Resi Marketplace :
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Typography variant="caption" display="block">
                            {suborder?.resi_otomatis_mp_resi}
                          </Typography>
                        </Grid>
                      </Grid>
                    </ListItem>
                  ) : null}
                  <Accordion
                    elevation={0}
                    classes={{
                      root: classes.accordion,
                      expanded: classes.expanded,
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMore />}
                      aria-controls="alamat-content"
                      id="alamat-header"
                    >
                      <Typography variant="caption" display="block">
                        Dikirim Ke: <b>{suborder?.alamat_tujuan?.judul} </b>
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.content}>
                      <Typography variant="caption" display="block">
                        Penerima:
                      </Typography>
                      <Typography
                        variant="caption"
                        display="block"
                      >{`${suborder?.alamat_tujuan?.nama_penerima} (${suborder?.alamat_tujuan?.no_telepon})`}</Typography>
                      <Gap height={8} />
                      <Typography variant="caption" display="block">
                        Alamat:
                      </Typography>
                      <Typography variant="caption" display="block">
                        {suborder?.alamat_tujuan?.alamat_lengkap},{" "}
                        {suborder?.alamat_tujuan?.kelurahan?.name},{" "}
                        {suborder?.alamat_tujuan?.kecamatan?.name},{" "}
                        {suborder?.alamat_tujuan?.kota?.name},{" "}
                        {suborder?.alamat_tujuan?.provinsi?.name}
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                  {suborder?.products.map((item, index) => {
                    return (
                      <ListItem divider className={classes.padding}>
                        <Grid container key={index}>
                          <Grid item style={{ width: 90 }}>
                            <img
                              width={60}
                              height={60}
                              src={item?.thumbnail?.[0]}
                              alt={item.nama}
                            />
                          </Grid>
                          <Grid item xs>
                            <Typography variant="caption" display="block">
                              {item.nama}
                            </Typography>
                            <Typography variant="caption" display="block">
                              {item.variant?.variant1?.nilai} -{" "}
                              {item.variant?.variant2?.nilai}
                            </Typography>
                            <Typography
                              variant="caption"
                              display="block"
                              color="secondary"
                            >
                              {currency(
                                (suborder?.products_subtotal?.[index] ?? 0) /
                                  (suborder?.products_qty?.[index] ?? 1)
                              )}{" "}
                              / Item
                            </Typography>
                          </Grid>
                          <Grid item style={{ width: 60 }}>
                            <Typography
                              variant="caption"
                              display="block"
                              align="center"
                              className={classes.qty}
                            >
                              x{suborder?.products_qty?.[index]}
                            </Typography>
                          </Grid>
                        </Grid>
                      </ListItem>
                    );
                  })}

                  <ListItem divider className={classes.padding}>
                    <Grid container>
                      <Grid item xs>
                        <Typography variant="caption" display="block">
                          Subtotal
                        </Typography>
                      </Grid>

                      <Grid item>
                        {suborder?.total_promo ? (
                          <Typography
                            variant="caption"
                            display="block"
                            style={{
                              textDecoration: "line-through",
                              color: "grey",
                            }}
                          >
                            {currency(
                              suborder?.total_tagihan + suborder?.total_promo
                            )}
                          </Typography>
                        ) : null}
                        <Typography
                          variant="caption"
                          display="block"
                          className={classes.price}
                          component="p"
                        >
                          {currency(suborder?.total_tagihan)}
                        </Typography>
                      </Grid>
                    </Grid>
                  </ListItem>

                  <ListItem divider className={classes.padding}>
                    <Grid container>
                      <Grid item xs>
                        <Typography variant="caption" display="block">
                          Diskon Produk
                        </Typography>
                      </Grid>

                      <Grid item>
                        <Typography variant="caption" display="block">
                          {currency(suborder?.total_promo)}
                        </Typography>
                      </Grid>
                    </Grid>
                  </ListItem>

                  <ListItem divider className={classes.padding}>
                    <Grid container>
                      <Grid item xs>
                        <Typography variant="caption" display="block">
                          Biaya Pengiriman
                        </Typography>
                      </Grid>

                      <Grid item>
                        {suborder?.promo_ongkir?.nilai ? (
                          <Typography
                            variant="caption"
                            display="block"
                            style={{
                              textDecoration: "line-through",
                              color: "grey",
                            }}
                          >
                            {currency(
                              suborder?.biaya_pengiriman +
                                suborder?.promo_ongkir?.nilai
                            )}
                          </Typography>
                        ) : null}
                        <Typography variant="caption" display="block">
                          {currency(suborder?.biaya_pengiriman)}
                        </Typography>
                      </Grid>
                    </Grid>
                  </ListItem>

                  <ListItem divider className={classes.padding}>
                    <Grid container>
                      <Grid item xs>
                        <Typography variant="caption" display="block">
                          Diskon Pengiriman
                        </Typography>
                      </Grid>

                      <Grid item>
                        <Typography variant="caption" display="block">
                          {currency(suborder?.promo_ongkir?.nilai)}
                        </Typography>
                      </Grid>
                    </Grid>
                  </ListItem>

                  <ListItem divider className={classes.padding}>
                    <Grid container>
                      <Grid item xs>
                        <Typography variant="caption" display="block">
                          Biaya Asuransi
                        </Typography>
                      </Grid>

                      <Grid item>
                        <Typography variant="caption" display="block">
                          {currency(suborder?.total_asuransi_pengiriman)}
                        </Typography>
                      </Grid>
                    </Grid>
                  </ListItem>

                  <ListItem divider className={classes.padding}>
                    <Grid container>
                      <Grid item xs>
                        <Typography variant="caption" display="block">
                          Berat Total
                        </Typography>
                      </Grid>

                      <Grid item>
                        <Typography variant="caption" display="block">
                          {delimiters(suborder?.dimensi_paket?.wt)} gr
                        </Typography>
                      </Grid>
                    </Grid>
                  </ListItem>

                  {order?.total_nilai_dp ? (
                    <ListItem divider className={classes.padding}>
                      <Grid container>
                        <Grid item xs>
                          <Typography variant="caption" display="block">
                            Total Nilai DP
                          </Typography>
                        </Grid>

                        <Grid item>
                          <Typography variant="caption" display="block">
                            {currency(order?.total_nilai_dp)}
                          </Typography>
                        </Grid>
                      </Grid>
                    </ListItem>
                  ) : (
                    ""
                  )}

                  {order?.total_nilai_dp ? (
                    <ListItem divider className={classes.padding}>
                      <Grid container>
                        <Grid item xs>
                          <Typography variant="caption" display="block">
                            Total Sisa Pembayaran
                          </Typography>
                        </Grid>

                        <Grid item>
                          <Typography variant="caption" display="block">
                            {currency(
                              suborder?.total_pembayaran -
                              order?.total_nilai_dp
                            )}
                          </Typography>
                        </Grid>
                      </Grid>
                    </ListItem>
                  ) : (
                    ""
                  )}

                  <ListItem className={classes.padding}>
                    <Grid container>
                      <Grid item xs>
                        <Typography variant="caption" display="block">
                          Total
                        </Typography>
                      </Grid>

                      <Grid item>
                        <Typography variant="caption" display="block">
                          {currency(suborder?.total_pembayaran)}
                        </Typography>
                      </Grid>
                    </Grid>
                  </ListItem>
                  {/* {order.status === "expired" || "not-paid" ? null : */}
                  <>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      size="small"
                      disabled={!suborder?.shipper_info}
                      style={{
                        marginBottom: 15,
                        width: "90%",
                        marginLeft: "5%",
                      }}
                      onClick={handleResi(suborder?.shipper_info?.resi_url)}
                    >
                      Cek Resi
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      size="small"
                      disabled={!suborder?.shipper_info || !suborder?.kurir}
                      style={{
                        marginBottom: 15,
                        width: "90%",
                        marginLeft: "5%",
                      }}
                      onClick={handleTrac(suborder)}
                    >
                      Tracking
                    </Button>
                  </>
                  {/* } */}
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    size="small"
                    style={{ marginBottom: 15, width: "90%", marginLeft: "5%" }}
                    onClick={handleWa(suborder?.alamat_tujuan?.no_telepon)}
                  >
                    Kontak Whatsapp
                  </Button>
                </Paper>{" "}
                <Gap height={10} />
              </div>
            );
          })}
          <Paper>
            <ListItem divider className={classes.pesanan}>
              <Grid container>
                <Grid item xs>
                  <Typography variant="caption" display="block">
                    <b>Detail Pesanan</b>
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem className={classes.padding}>
              <Grid container>
                <Grid item xs>
                  <Typography variant="caption" display="block">
                    Total Pesanan
                  </Typography>
                  <Typography variant="caption" display="block">
                    ({suborders?.length ?? 0} Pesanan)
                  </Typography>
                </Grid>

                <Grid item>
                  <Typography variant="caption" display="block">
                    {currency(order?.total_pembayaran)}
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
          </Paper>
        </DialogContent>
      )}
      <DialogTracking
        open={dialogTrac.open}
        subOrder={dialogTrac?.subOrder}
        handleClose={() => {
          setDialogTrac({
            open: false,
            subOrder: {},
          });
        }}
      />
    </Dialog>
  );
}

export default DetailDialog;
